var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { styled } from "../theme";
import { Icon } from "./Icon";
var IconGrid = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 20px;\n  padding: 20px;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 20px;\n  padding: 20px;\n"])));
var IconItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background: white;\n  transition: all 0.2s ease;\n\n  &:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    transform: translateY(-2px);\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background: white;\n  transition: all 0.2s ease;\n\n  &:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    transform: translateY(-2px);\n  }\n"])));
var IconWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n"], ["\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n"])));
var IconNameText = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 12px;\n  color: #666;\n  text-align: center;\n  word-break: break-word;\n  line-height: 1.2;\n"], ["\n  font-size: 12px;\n  color: #666;\n  text-align: center;\n  word-break: break-word;\n  line-height: 1.2;\n"])));
// All available icon names from the Icon component
export var ALL_ICON_NAMES = [
    "admin",
    "alert",
    "clock",
    "cloud",
    "dots",
    "down",
    "download",
    "download-cloud",
    "upload-cloud",
    "drag",
    "duplicate",
    "editor-bold",
    "editor-email",
    "editor-headline-main",
    "editor-headline-secondary",
    "editor-image",
    "editor-new-question",
    "editor-link",
    "editor-new-slide",
    "editor-new-text",
    "editor-ordered-list",
    "editor-small-text",
    "editor-unordered-list",
    "editor-video",
    "email",
    "left",
    "message",
    "message-alt",
    "notification",
    "options-checkboxes",
    "options-date",
    "options-file-upload",
    "options-dropdowns",
    "options-multiple-choice",
    "options-paragraph",
    "options-short-answer",
    "options-time",
    "pencil",
    "phone",
    "right",
    "search",
    "sort-down",
    "sort-up",
    "trash",
    "up",
    "user",
    "check-filled",
    "index",
    "check-circle",
    "add",
    "lock",
    "info",
    "a-letter",
    "camera",
    "text-size",
    "clear",
    "pause",
    "flag-alt",
    "flag-outlined",
    "house",
    "back",
    "close",
    "check",
    "audio",
    "reports",
    "permissions-share-access",
    "permissions",
    "compare",
    "analytics",
    "export",
    "overview",
    "trash-2",
    "arrow-up",
    "calendar",
    "flag",
    "arrows",
    "file-pdf",
    "arrows-cw",
    "town-hall",
    "grid",
    "cancel",
    "minus-1",
    "adjust",
    "na",
    "circle-empty",
    "angle-double-right",
    "block",
    "flash",
    "flash-outline",
    "help-circled-alt",
    "arrow-left",
    "arrow-down",
    "star",
    "star-empty",
    "th-large",
    "building",
    "building-filled",
    "th-large-outline",
    "th-list",
];
export var IconGallery = function () { return (React.createElement(IconGrid, null, ALL_ICON_NAMES.map(function (iconName) { return (React.createElement(IconItem, { key: iconName },
    React.createElement(IconWrapper, null,
        React.createElement(Icon, { name: iconName, size: 24 })),
    React.createElement(IconNameText, null, iconName))); }))); };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
